import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { CqFileDestination } from 'src/app/beans/components/cq-file/cq-file-destination.bean';
import { CustomValidator } from 'src/app/beans/errors/custom-validator.bean';
import { Organization } from 'src/app/beans/organization/organization.bean';
import { extensionMatch } from 'src/app/validators/extension.validator';
import { genericValidator } from 'src/app/validators/generic.validator';

@Component({
  selector: 'media-organization',
  templateUrl: './media-organization.page.html',
  styleUrls: ['./media-organization.page.scss']
})
export class MediaOrganizationPage implements OnInit {

  wapp_logo_validators: CustomValidator[] = [
    {
      isValid     :   Validators.required ,
      validation  :  {
        validatorName   : "required",
        text            : "media.validators.wapp.logo.required"
      }
    },
    {
      isValid     :   extensionMatch(['png', 'jpeg', 'jpg']) ,
      validation  :  {
        validatorName   : "png",
        text            : "media.validators.default.only_img"
      }
    }
  ]

  mapp_logo_validators: CustomValidator[] = [
    {
      isValid     :   Validators.required ,
      validation  :  {
        validatorName   : "required",
        text            : "media.validators.mapp.logo.required"
      }
    },
    {
      isValid     :   extensionMatch(['png', 'jpeg', 'jpg']) ,
      validation  :  {
        validatorName   : "png",
        text            : "media.validators.default.only_img"
      }
    }
  ]

  codi_validators: CustomValidator[] = [
    {
      isValid     :   extensionMatch(['png', 'jpeg', 'jpg']) ,
      validation  :  {
        validatorName   : "png",
        text            : "media.validators.default.only_img"
      }
    }
  ]

  tick_logo_validators: CustomValidator[] = [
    {
      isValid     :   Validators.required ,
      validation  :  {
        validatorName   : "required",
        text            : "media.validators.tick.logo.required"
      }
    },
    {
      isValid     :   extensionMatch(['png', 'jpeg', 'jpg']) ,
      validation  :  {
        validatorName   : "png",
        text            : "media.validators.default.only_img"
      }
    }
  ]

  tick_promo_validators: CustomValidator[] = [
    {
      isValid     :   extensionMatch(['png', 'jpeg', 'jpg']) ,
      validation  :  {
        validatorName   : "png",
        text            : "media.validators.default.only_img"
      }
    }
  ]

  summ_validators: CustomValidator[] = [
    {
      isValid     :   extensionMatch(['png', 'jpeg', 'jpg']) ,
      validation  :  {
        validatorName   : "png",
        text            : "media.validators.default.only_img"
      }
    }
  ]

  organization: Organization

  wapp_logo     = new FormControl  ('', genericValidator( this.wapp_logo_validators     ))

  mapp_logo     = new FormControl  ('', genericValidator( this.mapp_logo_validators     ))

  codi_logoh    = new FormControl ('', genericValidator( this.codi_validators           ))
  codi_logof    = new FormControl ('', genericValidator( this.codi_validators           ))
  codi_back     = new FormControl ('', genericValidator( this.codi_validators           ))

  tick_logo     = new FormControl  ('', genericValidator( this.tick_logo_validators     ))
  tick_promo    = new FormControl  ('', genericValidator( this.tick_promo_validators    ))

  summ_logoh    = new FormControl ('', genericValidator( this.summ_validators           ))
  summ_logof    = new FormControl ('', genericValidator( this.summ_validators           ))
  summ_back     = new FormControl ('', genericValidator( this.summ_validators           ))

  constructor() { }

  ngOnInit(): void {
  }
  
  onOrgChange(org: Organization){
    console.log( org );
    this.organization = org
  }

  getWappLogoDest(){
    return this.getMediaDest( "WAPP", "LOGO")
  }

  getMappLogoDest(){
    return this.getMediaDest( "MAPP", "LOGO")
  }

  getCodiLogoHDest(){
    return this.getMediaDest( "CODI", "LOGOH")
  }
  getCodiLogoFDest(){
    return this.getMediaDest( "CODI", "LOGOF")
  }
  getCodiBackDest(){
    return this.getMediaDest( "CODI", "BACK")
  }

  getTickLogoDest(){
    return this.getMediaDest( "TICK", "LOGO")
  }
  getTickPromoDest(){
    return this.getMediaDest( "TICK", "PROMO")
  }

  getSummLogoHDest(){
    return this.getMediaDest( "SUMM", "LOGOH")
  }
  getSummLogoFDest(){
    return this.getMediaDest( "SUMM", "LOGOF")
  }
  getSummBackDest(){
    return this.getMediaDest( "SUMM", "BACK")
  }

  getMediaDest(type: string, code: string): CqFileDestination
  {
    if(!this.organization?.id) return null
    return {
      level       : "OR",
      levelid     : this.organization?.id ,
      type        : type,
      code        : code
    }
  }

}
